document.addEventListener('DOMContentLoaded', function () {
    // Select slider buttons
    const realNextBtns = document.querySelectorAll('.product .product__media-wrapper [name="next"].slider-button');
    const realPrevBtns = document.querySelectorAll('.product .product__media-wrapper [name="previous"].slider-button');
    // Select custom control buttons
    const customNextBtn = document.querySelector('.custom-controls-next');
    const customPrevBtn = document.querySelector('.custom-controls-prev');
    // Select all thumbnail buttons
    const thumbnails = document.querySelectorAll('.product button.thumbnail');

    // Function to update disabled state of custom buttons based on active thumbnail
    function updateCustomControls() {
        const thumbArray = Array.from(thumbnails);
        const activeIndex = thumbArray.findIndex(thumb => thumb.getAttribute("aria-current") === "true");

        // If no active thumbnail found, we leave the controls enabled (or you could default to one state)
        if (activeIndex === -1) {
            customPrevBtn.removeAttribute("disabled");
            customNextBtn.removeAttribute("disabled");
            return;
        }

        // Disable previous button if the first thumbnail is active
        if (activeIndex === 0) {
            customPrevBtn.setAttribute("disabled", "");
        } else {
            customPrevBtn.removeAttribute("disabled");
        }

        // Disable next button if the last thumbnail is active
        if (activeIndex === thumbArray.length - 1) {
            customNextBtn.setAttribute("disabled", "");
        } else {
            customNextBtn.removeAttribute("disabled");
        }
    }

    // Handler for custom next button click
    customNextBtn.addEventListener('click', function () {
        // Do nothing if custom next button is disabled
        if (customNextBtn.hasAttribute("disabled")) return;

        // Trigger all real next button clicks
        realNextBtns.forEach(btn => btn.click());

        const thumbArray = Array.from(thumbnails);
        const activeIndex = thumbArray.findIndex(thumb => thumb.getAttribute("aria-current") === "true");

        // If there is a next thumbnail, click it
        if (activeIndex !== -1 && activeIndex < thumbArray.length - 1) {
            thumbArray[activeIndex + 1].click();
        }

        // Update the state of the custom buttons
        updateCustomControls();
    });

    // Handler for custom previous button click
    customPrevBtn.addEventListener('click', function () {
        // Do nothing if custom prev button is disabled
        if (customPrevBtn.hasAttribute("disabled")) return;

        // Trigger all real previous button clicks
        realPrevBtns.forEach(btn => btn.click());

        const thumbArray = Array.from(thumbnails);
        const activeIndex = thumbArray.findIndex(thumb => thumb.getAttribute("aria-current") === "true");

        // If there is a previous thumbnail, click it
        if (activeIndex > 0) {
            thumbArray[activeIndex - 1].click();
        }

        // Update the state of the custom buttons
        updateCustomControls();
    });

    // Initialize the state of the custom buttons on page load
    updateCustomControls();
});
